var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mian"},[_c('img',{staticClass:"arrow",attrs:{"src":require("../assets/imgs/arrow.png"),"alt":""}}),_c('p',{staticClass:"promise"},[_vm._v("請點擊右上角在瀏覽器打開下載APP")])])
}]

export { render, staticRenderFns }